import { render, staticRenderFns } from "./ExcelBatchRegistrationPopup.vue?vue&type=template&id=2edb44dc&"
import script from "./ExcelBatchRegistrationPopup.vue?vue&type=script&lang=ts&"
export * from "./ExcelBatchRegistrationPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports